import script from "./MainHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MainHeader.vue?vue&type=script&setup=true&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=765f7a86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-765f7a86"]])

export default __exports__